import { IQuizItem, TFormType } from '../../types/quiz';
import { TApplicationState } from '../../types/redux';

export const selectQuizItemByType =
  (type: TFormType) =>
  (state: TApplicationState): IQuizItem =>
    state.quizItems.items[type];
